import { useState, useEffect } from 'react'

export function useCountdown(
  initialHours: number = 23,
  initialMinutes: number = 59,
  initialSeconds: number = 59,
) {
  const [timeLeft, setTimeLeft] = useState(() => {
    return initialHours * 3600 + initialMinutes * 60 + initialSeconds
  })

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  const pad = (num: number) => num.toString().padStart(2, '0')

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    formatted: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
    isZero: timeLeft === 0,
  }
}
